import React from 'react'
import InputBox from '../../common/InputBox'
import IncomeHeader from '../../IncomeHeader'
import { financialYear } from '../../../../lib/financialYear'

class SelfEmployed extends React.Component {
  state = {
    frequency: this.props.income.frequency || 'yearly',
    frequencyPreviousYear: this.props.income.frequencyPreviousYear || 'yearly',
    incomeType: 'Incomes::SelfEmployed',
    option: 'self_employed',
  }

  componentDidMount() {
    this.updateIncome(this.state)
  }

  updateIncome = (params) => {
    let { income } = this.props
    this.props.onChange({
      ...{ key: income.key || 0 },
      ...params
    })
  }

  handleAmount = (e) => {
    const value = e.target.value.replace(/,/g, '')
    const amount = value ? parseInt(value) : null
    this.updateIncome({ amount })
  }

  handleFrequency = (frequency) => {
    this.updateIncome({ frequency })
  }

  handleAmountPreviousYear = (e) => {
    const value = e.target.value.replace(/,/g, '')
    const amount = value ? parseInt(value) : null
    this.updateIncome({ amountPreviousYear: amount })
  }

  handleFrequencyPreviousYear = (frequency) => {
    this.updateIncome({ frequencyPreviousYear: frequency })
  }

  render() {
    const {
      amount,
      frequency,
      amountPreviousYear,
      frequencyPreviousYear
    } = this.props.income

    const {
      iconName,
      title,
      isNested,
      errors,
    } = this.props

    return (
      <div className={ isNested ? 'income' : ''}>
        { isNested &&
          <IncomeHeader iconName={ iconName }
                        title={ title }
          />
        }

        <div className="mb-2">
          <InputBox
            label={ `What was your net profit in FY ${financialYear().lastYear}?` }
            labelClass='grey'
            type={ 'salaryAmount' }
            amount={ amount }
            frequency={ frequency }
            handleAmount={ this.handleAmount }
            handleFrequency={ this.handleFrequency }
            errorMessage={ errors && errors.amount }
            inputMode='numeric'
          />
        </div>

        <div className="mb-2">
          <InputBox
            label={ `What was your net profit in FY ${financialYear().yearBeforeLast}?` }
            labelClass='grey'
            type={ 'salaryAmountPreviousYear' }
            amount={ amountPreviousYear }
            frequency={ frequencyPreviousYear }
            handleAmount={ this.handleAmountPreviousYear }
            handleFrequency={ this.handleFrequencyPreviousYear }
            errorMessage={ errors && errors.amountPreviousYear }
            inputMode='numeric'
          />
        </div>
      </div>
    )
  }
}

export default SelfEmployed
